export default __webpack_public_path__ + "static/media/2013.14117a64.svg";